<template>
  <div style="position:relative;width:100%;height:100%">
    <div id="widget-plot-container" style="height:100%;display:flex">
      <PlotCreator class="widget-plot-chart"
      :tag='tag' ref="plotChart"/>
    </div>
    <EMWidgetSettings
      @dialogStateChangeEvent='changeSettingsDialogState'
      @saveSettingsEvent='saveTagSettings'
      :isOpen='settingsDialog'
      :title='title'
      :dialogWidth='800'
      :submitDisable="settings.tag.name !== '' && settings.tag.name !== undefined"
      :disableWarningMsg="$t('form_warnings.no_tags_selected')"
      ref="settings"
    >
      <div class='tag-group-header'>
        <div class="wdgt-settings-card-label">{{ $t('tag') }}</div>
        <v-spacer></v-spacer>
      </div>
      <div class="tag-group-settings justify-space-between text-center">
        <div class="tag-group my-3 mr-2" >
          <label>{{ $t('tag_name') }}</label>
          <v-container>
              <div class="text-center">
                <EMTagSelect
                v-if="settingsDialog"
                :tag="settings.tag"
                @updateTagValue="updateNameAndValue($event)"/>
              </div>
          </v-container>
        </div>
        <div class="my-3 mr-2">
          <EMTextArea
            :inputValue="settings.tag.unit"
            :label="$t('unit')"
            @value-changed="settings.tag.unit = $event"
            :isDisabled="true"
          />
        </div>
      </div>
    </EMWidgetSettings>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WidgetBasicMixin from '@/components/Widgets/mixins/widget-basic-mixin';
import EMPlotChartCreator from './charts/EMPlotChartCreator.vue';
import EMTextArea from './Inputs/EMTextArea.vue';

export default {
  name: 'EMWidgetPlotChart',
  props: {
    settingsDialog: {
      type: Boolean,
      default: false,
    },
    widgetData: {
      type: Object,
    },
    widgetTitle: {
      type: String,
    },
  },
  mixins: [WidgetBasicMixin],
  components: {
    PlotCreator: EMPlotChartCreator,
    EMTextArea,
  },
  data() {
    return {
      title: '',
      tag: { id: '', name: '', unit: '' },
      series: {},
      settings: {
        tag: { id: '', name: '' },
      },
      tagLimit: 1,
      tagsTypeList: [],
      editedTagSelector: false,
    };
  },
  computed: {
    ...mapGetters(['getTagsList', 'getTagDataById', 'getTagDataByName']),
  },
  methods: {
    updateNameAndValue(tagObject) {
      if (Object.keys(tagObject).length === 0) {
        this.editedTagSelector = true;
        return;
      }
      this.settings.tag.name = tagObject.tagName;
      this.settings.tag.id = tagObject.tagId;
      this.settings.tag.unit = tagObject.unit;
      this.editedTagSelector = false;
      this.$emit('updateTagWidgetEvent', tagObject.tagName);
      this.$nextTick(() => {
        this.reflowChart();
      });
    },
    saveTagSettings(title) {
      this.title = title;
      this.tag = JSON.parse(JSON.stringify(this.settings.tag));
      this.setPlotSeriesData();

      const uniqueTagList = [this.tag.name];
      const widgetData = {
        tag: this.tag,
      };
      this.$emit('updateSettingsWidgetEvent', title, widgetData, uniqueTagList);
      this.$nextTick(() => {
        this.reflowChart();
      });
    },
    getAllTags() {
      this.tagsTypeList = this.getTagsList;
    },
    setPlotSeriesData() {
      const tagObject = {
        name: `${this.tag.name} [${this.tag.unit}]`,
        data: [0],
      };
      this.series = tagObject;
    },
    reflowChart() {
      if ((this.$refs.plotChart && this.$refs.plotChart.$refs.emChart)
        && (this.$refs.plotChart.$refs.emChart.$refs.chart
          && this.$refs.plotChart.$refs.emChart.$refs.chart.chart)) {
        this.$refs.plotChart.$refs.emChart.$refs.chart.chart.reflow();
      }
    },

    resetSettingChanges() {
      this.settings.tag = JSON.parse(JSON.stringify(this.tag));
    },
  },
  created() {
    this.getAllTags();
    this.title = this.widgetTitle;
    this.tag = this.widgetData.tag ? this.widgetData.tag : { id: '', name: '', unit: '' };
    this.settings.tag = JSON.parse(JSON.stringify(this.tag));
    this.setPlotSeriesData();
  },
};
</script>

<style>
.widget-plot-wrapper{
  display: flex;
  flex-flow: column;
  justify-content: space-evenly;
  height:80%;
}
.widget-plot-wrapper-horz{
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}
.widget-plot-color{
  width:30px;
  min-width:30px;
  height: 30px;
  position: relative;
}
.tag-group{
  height: 55px;
}
.tag-group .v-input__slot{
  box-shadow: none !important;
}
.tag-group .v-input__control{
  min-height: 0 !important;
}
.widget-plot-chart{
  width: 80%;
}
/* important necessary to override inline styles from the library*/
.widget-plot-chart > div{
  width: 100% !important;
  height: 100% !important;
}
.widget-plot-chart > div > div{
  width: 100% !important;
}
.widget-plot-chart > div > div > svg{
  width: 100% !important;
  height: 100% !important;
}
.w-33{
  max-width: 32.5% !important;
}
.w-20{
  width: 20% !important;
}
.w-50{
  width: 50% !important;
}

</style>
